import {AxiosInstance, AxiosRequestConfig} from "axios";
import HistoricalJobImport from "../model/historicalJobImport/HistoricalJobImport";

export default class HistoricalJobImportApi {

	constructor(public readonly axiosInstance: AxiosInstance) {}

	getHistoricalJobImports(): Promise<HistoricalJobImport[]> {
		const url = `/api/web/historical-jobs/imports`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(HistoricalJobImport.fromJson));
	}

	startImport(file: File): Promise<string> {
		const url = `/api/web/historical-jobs/import`;
		const config: AxiosRequestConfig = {headers: {'content-type': 'multipart/form-data'}, timeout: 300000};
		const formData = new FormData();
		formData.append('file', file);
		return this.axiosInstance.post(url, formData, config).then(resp => resp.data.importId);
	}

	getErrorReportUrl(importId: string): Promise<string> {
		const url = `/api/web/historical-jobs/import/${importId}/errors`;
		return this.axiosInstance.get(url).then(resp => resp.data.url);
	}
}
